module.exports = __webpack_public_path__ + "static/5-ca629bcb9ad021e503033e20ff8790d8.svg";